import clsx from "clsx";

interface QuestionButtonProps {
  label: string;
  isSelected: boolean;
  isDisabled: boolean;
  clickFn: () => void;
}

export const QuestionButton: React.FC<QuestionButtonProps> = (props) => {
  return (
    <div className="lander__quiz__button-container">
      <button
        className={clsx(
          "lander__quiz__button",
          props.isSelected && "lander__quiz__button--selected"
        )}
        disabled={props.isDisabled}
        onClick={props.clickFn}
      >
        {props.label}
      </button>
    </div>
  );
};
